import * as Factory from 'factory.ts'
import faker from 'faker'

import { type PaymentApprover } from '@webapp/models'
import { SimpleUserMock } from './user.factory'

export const PaymentApproverMock = Factory.Sync.makeFactory<PaymentApprover>({
  id: Factory.each(() => faker.random.number()),
  amount_limit: '100',
  approval_level: 0,
  bill_amount_limit: '100',
  item_variance_amount_limit: '0',
  item_variance_percentage_limit: '0',
  user: Factory.each(() => {
    const { id, email, firstName, lastName, profile_image } =
      SimpleUserMock.build()

    return {
      id,
      email,
      first_name: firstName,
      last_name: lastName,
      profile_image,
      user_id: id,
      approval_delegatee: null,
    }
  }),
})
